import {ChangeDetectionStrategy, Component, forwardRef, Input, OnInit} from '@angular/core';
import {ControlValueAccessor, FormBuilder, FormGroup, NG_VALUE_ACCESSOR} from '@angular/forms';
import * as _ from 'lodash';

@Component({
  selector: 'app-checkbox-input-indra',
  templateUrl: './checkbox-input-indra.component.html',
  styleUrls: ['./checkbox-input-indra.component.scss'],
	providers: [
		{
			/**
			 * Custom Control value accessor
			 */
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => CheckboxInputIndraComponent),
			multi: true
		}
	],
	host: {
		class: 'app-checkbox-input-indra'
	},
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckboxInputIndraComponent implements ControlValueAccessor, OnInit {

	public form: FormGroup = this.fb.group({
		checkbox: [null]
	});

	@Input()
	public label = 'Checkbox label';

	@Input()
	public checked = false;

	@Input()
	public align_right = false;

	@Input()
	public disabled = false;

	private _value: boolean;

	private propagateChange = (n: any) => { };

	get value(): boolean {
		return this._value;
	}

	set value(newValue: boolean) {
		this._value = newValue;
		this.form.patchValue({checkbox: this.value});
		this.propagateChange(this.value);
	}

	constructor(
		private fb: FormBuilder
	) { }

	ngOnInit(): void {
		this.form.get('checkbox').valueChanges.subscribe(newValue => {
			this.writeValue(newValue);
		});
	}

	registerOnChange(fn: any): void {
		this.propagateChange = fn;
	}

	registerOnTouched(fn: any): void {
		//
	}

	writeValue(obj: any): void {
		if (!_.isEqual(this.value, obj)) {
			this.value = obj;
		}
	}

}
